import dayjs from "dayjs";
import axios from "axios";

// Shared logic to avoid duplication
const formatNumber = (value, decimal) => {
  if (!value && value !== 0) return "";
  return decimal !== undefined
    ? value.toLocaleString("en-US", {
      minimumFractionDigits: decimal,
      maximumFractionDigits: decimal,
    })
    : value.toLocaleString("en-US");
};
const date = (v) => dayjs(v).format("DD/MM/YYYY");
const datetime = (v) => dayjs(v).format("DD/MM/YYYY HH:mm:ss");
const time = (v) => dayjs(v).format("HH:mm:ss");
const formatDayDate = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  const days = [
    "ວັນອາທິດ",
    "ວັນຈັນ",
    "ວັນອັງຄານ",
    "ວັນພຸດ",
    "ວັນພະຫັດ",
    "ວັນສຸກ",
    "ວັນເສົາ",
  ];
  return `${days[date.getDay()]}, ${dayjs(dateString).format(
    "DD/MM/YYYY",
  )}`;
};

const computeGradeLogic = (point, configList) => {
  if (point == null || point === "") return "-";
  const value = Number(point);
  if (Number.isNaN(value)) return "-";

  if (configList && configList.length > 0) {
    const found = configList.find((c) => value >= c.min_score && value <= c.max_score);
    if (found) return found.grade;
  }

  return "-";
};

const getRoleName = (role) => {
      if (!role) return "-";
      let output = typeof role === "string" ? role : role.name || "-";
      if (output === "SUPERADMIN") {
        output = "ຊຸບເປີແອັດມິນ";
      } else if (output === "TEACHER") {
        output = "ຄູສອນ";
      } else if (output === "ADMIN") {
        output = "ແອັດມິນ";
      } else if (output === "STAFF") {
        output = "ພະນັກງານ";
      } else if (output === "REGISTRANT") {
        output = "ຜູ້ລົງທະບຽນ";
      } else if (output === "GRADER") {
        output = "ຜູ້ໃຫ້ຄະແນນ";
      } else if (output === "LIBRARIAN") {
        output = "ບັນນະລັກ";
      }
      return output;
    };

const getStatusLabel = (status) => {
  const normalized = (status || "").toString().toUpperCase();
  const map = {
    ມາ: "ມາເຂົ້າຮຽນ",
    ສາຍ: "ມາສາຍ",
    ຄລ: "ຄຳຮ້ອງລາ",
    ຂາດ: "ຂາດຮຽນ",
    PRESENT: "ມາເຂົ້າຮຽນ",
    ABSENT: "ຂາດ",
    REASONABLE: "ຂາດມີເຫດຜົນ",
    DRAFT: "ກຳລັງຮ່າງ",
    SUBMITTED: "ສົ່ງແລ້ວ",
    ACTIVE: "ກຳລັງສຶກສາ",
    PENDING: "ລໍຖ້າອະນຸມັດ",
    GRADUATED: "ສຳເລັດການສຶກສາ",
    DEFENSE1: "ປ້ອງກັນຮອບທີ 1",
    DEFENSE2: "ປ້ອງກັນຮອບທີ 2",
    SUSPENDED: "ໂຈະການຮຽນ",
    DROPPED: "ອອກຮຽນ",
    COMPLETED: "ສຳເລັດ",
    CANCELED: "ຍົກເລີກ",
    CANCELLED: "ຍົກເລີກ",
    DELETED: "ລຶບແລ້ວ",
  };
  return map[normalized] || status || "-";
};

export default {
  data() {
    return {};
  },
  filters: {
    formatNumber,
    date,
    datetime,
    time,
    formatDayDate,
    attendancestatus: getStatusLabel,
    getStatusLabel,
    getRoleName,
  },
  methods: {
    formatNumber,
    date,
    datetime,
    time,
    getStatusLabel,
    formatDayDate,
    getRoleName,

    getPhotoUrl(photo) {
      if (!photo) return "";
      if (photo.startsWith("http://") || photo.startsWith("https://")) {
        return photo;
      }
      const baseUrl = axios.defaults.baseURL || process.env.VUE_APP_URLAPP || "";
      return `${baseUrl}${photo}`;
    },
    isImage(filename) {
      if (!filename) return false;
      const ext = filename.split(".").pop().toLowerCase();
      return ["jpg", "jpeg", "png", "gif", "webp"].includes(ext);
    },
    getFileUrl(file) {
      if (!file) return "";
      const baseUrl = axios.defaults.baseURL || process.env.VUE_APP_URLAPP || "";
      const fileUrl = typeof file === 'string' ? file : (file.url || file.filename);
      if (typeof fileUrl !== 'string') return "";
      return fileUrl.startsWith("http") ? fileUrl : `${baseUrl}${fileUrl}`;
    },
    getFileIcon(filename) {
      if (!filename) return "mdi-file-outline";
      const ext = filename.split(".").pop().toLowerCase();
      if (ext === "pdf") return "mdi-file-pdf-box";
      return "mdi-file-outline";
    },
    openFile(file) {
      const link = document.createElement("a");
      link.href = this.getFileUrl(file);
      link.target = "_blank";
      link.click();
    },
    getInitials(s) {
      if (!s) return "?";
      return ((s.firstname?.charAt(0) || "") + (s.lastname?.charAt(0) || "")).toUpperCase() || "?";
    },

    computeGrade(val, systemId) {
      const allConfigs = this.$store.state.gradingConfig || [];
      const targetSystemId = systemId || null;
      let sysConfigs = allConfigs.filter(c => c.system_id === targetSystemId);
      if (sysConfigs.length === 0 && targetSystemId !== null) {
        sysConfigs = allConfigs.filter(c => c.system_id === null);
      }
      if (sysConfigs.length === 0 && allConfigs.length > 0) {
        const fallbackSystemId = allConfigs[0].system_id;
        sysConfigs = allConfigs.filter(c => c.system_id === fallbackSystemId);
      }

      return computeGradeLogic(val, sysConfigs);
    },

    getGpaPoint(grade, systemId) {
      if (!grade) return 0;
      const normalized = grade.toString().trim().toUpperCase();
      const defaultMap = {
        'A': 4.0,
        'B+': 3.5,
        'B': 3.0,
        'C+': 2.5,
        'C': 2.0,
        'D+': 1.5,
        'D': 1.0,
        'F': 0.0
      };
      const allConfigs = this.$store?.state?.gradingConfig || [];
      if (allConfigs && allConfigs.length > 0) {
        const targetSystemId = systemId || null;
        let sysConfigs = allConfigs.filter(c => c.system_id === targetSystemId);
        if (sysConfigs.length === 0 && targetSystemId !== null) {
          sysConfigs = allConfigs.filter(c => c.system_id === null);
        }
        if (sysConfigs.length === 0 && allConfigs.length > 0) {
          sysConfigs = allConfigs;
        }
        const found = sysConfigs.find(c => (c.grade || "").toString().toUpperCase() === normalized);
        if (found && found.gpa_point !== undefined && found.gpa_point !== null) {
          return Number(found.gpa_point);
        }
      }
      return defaultMap[normalized] ?? 0;
    },

    getGradeRemark(grade, systemId) {
      if (!grade) return "";
      const normalized = grade.toString().trim().toUpperCase();
      const allConfigs = this.$store?.state?.gradingConfig || [];
      if (allConfigs && allConfigs.length > 0) {
        const targetSystemId = systemId || null;
        let sysConfigs = allConfigs.filter(c => c.system_id === targetSystemId);
        if (sysConfigs.length === 0 && targetSystemId !== null) {
          sysConfigs = allConfigs.filter(c => c.system_id === null);
        }
        if (sysConfigs.length === 0 && allConfigs.length > 0) {
          sysConfigs = allConfigs;
        }
        const found = sysConfigs.find(c => (c.grade || "").toString().toUpperCase() === normalized);
        if (found) {
          return found.remark || "";
        }
      }
      return "";
    },

    gradeClass(prefix, grade) {
      const normalized = (grade || "").toString().toUpperCase();
      const colors = {
        A: "emerald-600",
        "B+": "sky-600",
        B: "blue-600",
        "C+": "amber-700",
        C: "yellow-700",
        "D+": "orange-600",
        D: "orange-500",
        F: "red-600",
      };
      return `${prefix}-${colors[normalized] || "gray-700"}`;
    },
    gradeTextClass(grade) { return this.gradeClass("text", grade); },
    gradeBgClass(grade) { return this.gradeClass("bg", grade); },

    getStatusBadge(status) {
      const label = getStatusLabel(status);
      const normalized = (status || "").toString().toUpperCase();
      const colorMap = {
        DRAFT: "bg-yellow-100 text-yellow-800",
        SUBMITTED: "bg-purple-100 text-purple-800",
        ACTIVE: "bg-green-100 text-green-800",
        PENDING: "bg-orange-100 text-orange-800",
        GRADUATED: "bg-blue-100 text-blue-800",
        DEFENSE1: "bg-sky-100 text-sky-800",
        DEFENSE2: "bg-indigo-100 text-indigo-800",
        SUSPENDED: "bg-amber-100 text-amber-800",
        DROPPED: "bg-red-100 text-red-800",
        COMPLETED: "bg-blue-100 text-blue-800",
        CANCELED: "bg-red-100 text-red-800",
        CANCELLED: "bg-red-100 text-red-800",
      };
      const iconMap = {
        DRAFT: "mdi-file-document-outline",
        SUBMITTED: "mdi-send-check",
        ACTIVE: "mdi-check-circle-outline",
        PENDING: "mdi-clock-outline",
        GRADUATED: "mdi-school",
        DEFENSE1: "mdi-numeric-1-circle",
        DEFENSE2: "mdi-numeric-2-circle",
        SUSPENDED: "mdi-pause-circle",
        DROPPED: "mdi-close-circle",
        COMPLETED: "mdi-checkbox-marked-circle-outline",
        CANCELED: "mdi-cancel",
        CANCELLED: "mdi-cancel",
      };
      return {
        label,
        color: colorMap[normalized] || "bg-gray-100 text-gray-800",
        icon: iconMap[normalized] || "mdi-information-outline",
      };
    },

    getStatusClass(status) {
      const badge = this.getStatusBadge(status);
      return badge.color;
    },

    t(texts) {
      return texts[this.$store.state.lang] || texts[0];
    },

    getflutter() {
      if (window["flutter_inappwebview"]) return window["flutter_inappwebview"];
      // Note: busy wait loop removed for performance, use async handlers if possible
      return null;
    },

    async confirmDeleteWithPassword(itemText) {
      const result = await this.$swal.fire({
        title: "ຢືນຢັນການລຶບ",
        text: `ທ່ານຕ້ອງການລຶບ "${itemText}" ຫຼືບໍ່? ກະລຸນາປ້ອນລະຫັດຜ່ານເພື່ອຢືນຢັນ`,
        input: "password",
        inputAttributes: {
          autocapitalize: "off",
          placeholder: "ປ້ອນລະຫັດຜ່ານ...",
          autocomplete: "new-password",
        },
        showCancelButton: true,
        confirmButtonText: "ຢືນຢັນ",
        cancelButtonText: "ຍົກເລີກ",
        confirmButtonColor: "#ef4444",
        cancelButtonColor: "#6b7280",
        showLoaderOnConfirm: true,
        preConfirm: (password) => {
          return axios
            .post("/verify-password", { password })
            .then((response) => {
              if (response && response.result === "OK") {
                return true;
              } else {
                throw new Error(response.message || "ລະຫັດຜ່ານບໍ່ຖືກຕ້ອງ");
              }
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`ຜິດພາດ: ${error.message}`);
            });
        },
        allowOutsideClick: () => !this.$swal.isLoading(),
      });
      return result.isConfirmed;
    }
  }
};
